import { useEffect, useState } from "react";
import { NeedHelp, SearchIcon } from "../../../atoms/CustomIcons";
import Header from "../../../atoms/Header";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import DashboardTemplate from "../../../templates/Dashboard";
import EditableTable from "./Components/EditableTable";
import { getUnitsById, removeUnitListingData } from "./ducks/actions";
import { Input } from "antd";
import { UnitsTableType } from "./ducks/types";

export default function MeasurementsUnits() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [data, setData] = useState<UnitsTableType[]>([]);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const unitListing = useAppSelector((state) => state?.unit?.unitsData);

  useEffect(() => {
    if (companyId) {
      dispatch(getUnitsById(companyId));
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    dispatch(removeUnitListingData());
  }, [dispatch]);

  useEffect(() => {
    const currentData = unitListing?.data;
    let filteredData: UnitsTableType[] = [];

    if (value && currentData) {
      filteredData = currentData?.filter((entry) => {
        const typedData = value
          ? entry?.name && entry?.name.toLowerCase().includes(value)
          : true;

        return typedData;
      });
      setData(filteredData);
    } else {
      setData(unitListing?.data ?? []);
    }
  }, [value, unitListing]);

  return (
    <DashboardTemplate loading={unitListing?.loader || loading}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/${companyId}` },
          { label: "Measurement units" },
        ]}
        title="Measurement units"
        description="Add or edit units to ensure consistency and accuracy across tasks, reports, and calculations."
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />
      <div className="maxWidth" style={{ maxWidth: "1200px" }}>
        <div className="search_box">
          <Input
            placeholder="Search Measurement Unit"
            value={value}
            onChange={(e) => setValue(e?.target?.value?.toLowerCase())}
            prefix={<SearchIcon />}
            allowClear
          />
        </div>
        <div className="tableScroll">
          <EditableTable
            data={data}
            setLoading={setLoading}
            loading={loading}
          />
        </div>
      </div>
    </DashboardTemplate>
  );
}
